<template>
  <div :class="$style.item">
    <!-- 标题 -->
    <div :class="$style.title">
      <span :class="$style.tag" v-show="topicItem.is_essence == 1">精华</span>
      <span class="title">{{ topicItem.title }}</span>
    </div>
    <!-- 帖子内容 -->
    <div
      v-if="textContent"
      class="content_split"
      :class="$style.content"
      v-html="textContent"
    ></div>
    <!-- 帖子显示图片 -->
    <div :class="$style.imglist">
      <img v-for="(item, index) of imgList" :key="index" v-show="index < 3" v-lazy="item" />
    </div>
    <!-- 底部 -->
    <div :class="$style.footer">
      <div>
        <div :class="$style.author">
          <img :src="`${$cdnUrl}/logo_2.png`" alt />
          <span class="forum_name">{{ topicItem.forum_name }}</span>
        </div>
        <div :class="$style.createtime">
          <img :src="`${$cdnUrl}/time.png`" alt />
          <span>{{ isNew ? topicItem.updated_at : topicItem.created_at }}</span>
        </div>
      </div>
      <div>
        <!-- 回复数 -->
        <div :class="$style.reply">
          <img :src="`${$cdnUrl}/chat_1.png`" alt />
          <span>{{ topicItem.comment }}</span>
        </div>
        <!-- 点赞 -->
        <div :class="$style.praise" @click.stop="handlePraise(topicItem)">
          <img
            :src="topicItem.is_support ? `${$cdnUrl}/red_praise_1.png` : `${$cdnUrl}/praise_1.png`"
            alt
          />
          <span :style="{ color: topicItem.is_support ? '#fb7166' : '' }">{{
            topicItem.support
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doPraise } from '@/api/gameCircle';
import { reportData } from '@/api/report';
import { mapActions, mapState, mapMutations } from 'vuex';
import _ from 'lodash';
export default {
  props: {
    topicItem: {
      type: Object,
      default: () => {},
    },
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      textContent: '',
      imgList: [],
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    // 游戏圈id
    circleId() {
      return this.$route.query.circleId;
    },
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false;
      return flag;
    },
  },
  created() {
    this.setTopicContent();
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
    }),
    setTopicContent() {
      let content = {};
      if (!this.topicItem.content || this.topicItem.content[0] != '{') return '';
      try {
        content = JSON.parse(this.topicItem.content);
      } catch {
        return '';
      }
      this.textContent = content.textContent || '';
      this.imgList = content.imgList || [];
    },
    async handlePraise(topicItem) {
      reportData({
        type: 5,
        data_type: 12,
        circle_id: this.circleId,
        conversation_id: topicItem.id,
      });
      if (!this.isRegister) {
        this.CHANGE_REGISTER_DIALOG(true);
        return;
      }
      if (topicItem.is_support) return;
      const r = await doPraise({
        conversation_id: topicItem.id,
      });
      topicItem.is_support = 1;
      topicItem.support = Number(topicItem.support) + 1;
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.item {
  @include border-bottom-1px;
  padding: 10px 15px 0 15px;
  &.active {
    background: rgb(236, 236, 236);
  }
  background-color: #fff;
  .title {
    width: 95%;
    font-size: 14px;
    font-weight: 400;
    line-height: 15px;
    display: flex;
    align-items: start;
    margin-bottom: 10px;
    .tag {
      display: inline-block;
      width: 28px;
      height: 15px;
      background: linear-gradient(-90deg, rgba(38, 212, 202, 1), rgba(87, 227, 182, 1));
      border-radius: 2px;
      color: #ffffff;
      font-size: 11px;
      flex: none;
      text-align: center;
      margin-right: 6px;
      padding-top: 1px;
    }
  }
  .content {
    @include ellipsis(2);
    position: relative;
    margin-bottom: 7px;
    width: 95%;
    max-height: 3em;
    font-size: 12px;
    color: #9f9f9f;
    overflow: hidden;
    line-height: 1.5em;
    text-align: justify;
    white-space: pre-line;
    :global {
      .hm-emoji {
        vertical-align: text-bottom;
      }
    }
  }
  .imglist {
    display: flex;
    > img {
      width: 105px;
      height: 105px;
      border-radius: 2px;
      margin-right: 5px;
      object-fit: cover;
    }
  }
  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #9f9f9f;
    font-size: 11px;
    > div {
      display: flex;
      align-items: center;
      margin-right: 2px;
    }
    img {
      height: 11px;
      width: 11px;
      margin-right: 3px;
    }
    .author,
    .createtime,
    .praise,
    .reply {
      display: flex;
      align-items: center;
    }
    .author,
    .reply {
      margin-right: 7px;
    }
    .reply,
    .praise {
      margin: 0;
      box-sizing: content-box;
      padding: 10px 5px 10px 5px;
    }
    // .author {
    //   @include ellipsis(1);
    //   width: 120px;
    // }
    // .createTime {
    //   width: 130px;
    // }
    // .reply {
    //   margin-left: 18px;
    //   width: 40px;
    //   padding: 10px 2px 10px 2px;
    //   box-sizing: content-box;
    // }
    // .praise {
    //   margin: 0;
    //   width: 40px;
    //   padding: 10px 2px 10px 2px;
    //   box-sizing: content-box;
    // }
  }
}
</style>
